module.exports = __webpack_public_path__ + "static/fonts/Mont-HeavyItalic.d9fcfc7.eot";